import type {PropsWithChildren} from 'react'
import {createContext, use} from 'react'

const MergeBoxLayoutContext = createContext<boolean>(false)

export function MergeBoxLayoutProvider({children, isSidePanel = false}: PropsWithChildren<{isSidePanel?: boolean}>) {
  return <MergeBoxLayoutContext value={isSidePanel}>{children}</MergeBoxLayoutContext>
}

export function useIsMergeBoxSidePanel(): boolean {
  return use(MergeBoxLayoutContext)
}
